<p-table [value]="filasTransformadas" [paginator]="true" [rows]="rowsPerPage" [totalRecords]="totalRecords"
  [rowsPerPageOptions]="rowsPerPageOptions" [lazy]="true" (onLazyLoad)="onLoadRecords($event)" showGridlines="true"
  [scrollable]="true" [rowHover]="true" styleClass="text-xs p-datatable-sm compact-table w-full">
  <ng-template pTemplate="header">
    <tr class="bg-surface-50 text-center">
      @if (tableSubject$ | async; as table) {
      @for (col of table.columns; track col) {
      <th>{{ col.label }}</th>
      }
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr>
      <td class="p-1 text-center">{{ row.IdMulti }}</td>
      <td class="p-1 text-center">{{ row.IdPaquete }}</td>
      @if (row.tipo !== null) {
      <td [attr.rowspan]="row.rowspan" class="p-1 text-center ">
        {{ row.tipo }}
      </td>
      }
      <td class="p-1 text-center">{{ row.Ano }}</td>
    </tr>
  </ng-template>
</p-table>